import React, { useCallback, useEffect, useRef, } from 'react';
import { TextLink } from '../../../LinkV2';
import { NavBarPopover } from '../../Popover';
import { trackCat } from '../../constants';
import { useTheme } from 'styled-components';
export const S4XDropdown = ({ popoverLinks, label, trackingLabels, onOpen, onClose, opened, }) => {
    const timeout = useRef(null);
    const handleOnMouseDown = useCallback(e => {
        e.preventDefault();
        if (opened) {
            onClose();
        }
        else {
            onOpen();
        }
    }, [opened, onOpen, onClose]);
    const handleOnKeyDown = useCallback(e => {
        if (e.key === ' ' || e.key === 'Enter') {
            e.preventDefault();
            if (opened) {
                onClose();
            }
            else {
                onOpen();
            }
        }
    }, [opened, onOpen, onClose]);
    useEffect(() => {
        if (!opened && timeout.current) {
            clearTimeout(timeout.current);
            timeout.current = null;
        }
    }, [opened]);
    const handleOnMouseLeave = useCallback(() => {
        timeout.current = setTimeout(() => {
            onClose();
        }, 500);
    }, [onClose]);
    const handleOnMouseEnter = useCallback(() => {
        if (timeout.current) {
            clearTimeout(timeout.current);
            timeout.current = null;
        }
        onOpen();
    }, [onOpen]);
    const theme = useTheme();
    return (React.createElement(NavBarPopover, { isOpen: opened, links: popoverLinks, onMouseEnter: handleOnMouseEnter, onMouseLeave: handleOnMouseLeave },
        React.createElement(TextLink, { href: "", svgIcon: opened ? 'IconChevronUp' : 'IconChevronDown', trackingCategory: trackCat, color: theme.text, size: "xsmall", onMouseDown: handleOnMouseDown, onKeyDown: handleOnKeyDown, trackingLabel: opened ? trackingLabels.open : trackingLabels.closed, label: label })));
};
//# sourceMappingURL=index.js.map